import AntDesignVue, { message } from 'ant-design-vue';
import { BaseService } from '@triascloud/services';
import XComponents from '@triascloud/x-components';
import request from './services/request';
import NoDataChart from '@/components/no-data-chart';
import EmptyContent from '@/components/empty-content';
import { nowSize } from '@/utils/common.js';

export default function install(Vue) {
  Vue.component('NoDataChart', NoDataChart);
  Vue.component('EmptyContent', EmptyContent);
  // 全局注册ant-design-vue
  Vue.use(AntDesignVue);
  // 全局注册x-
  Vue.use(XComponents, {
    // scriptUrl: '//at.alicdn.com/t/font_2003313_h2cz17xo8me.js',
    // scriptColorUrl: '//at.alicdn.com/t/font_2070557_x6d6j9qm4h.js',
    scriptUrl: `//cdn.${process.env.VUE_APP_HOST}/icon/20230323aaERlGCSNG.js`,
    scriptColorUrl: `//cdn.${process.env.VUE_APP_HOST}/icon/20221019aaYSSWNPU5.js`,
  });
  // 为Service注入request
  BaseService.request = request;
  Vue.config.productionTip = false;

  Vue.prototype.$message = message;
  Vue.prototype.$preview = XComponents.Preview.createModal;
  Vue.prototype.$size = nowSize;
}
